import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from '../lib/i18n';
export function CookieConsent() {
  const {
    t
  } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Small delay to not be jarring on load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };
  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-45">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 flex justify-center pointer-events-none" data-id="element-46">
          <div className="bg-surface border border-gray-200 shadow-2xl rounded-2xl p-6 max-w-lg w-full pointer-events-auto flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-47">
            <div className="flex-1 text-center md:text-left" data-id="element-48">
              <p className="text-text-primary font-sans text-sm leading-relaxed" data-id="element-49">
                {t.cookie.text}
              </p>
            </div>
            <div className="flex gap-3 w-full md:w-auto" data-id="element-50">
              <button onClick={handleDecline} className="flex-1 md:flex-none px-4 py-2 rounded-lg border border-gray-300 text-text-secondary text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-51">
                {t.cookie.decline}
              </button>
              <button onClick={handleAccept} className="flex-1 md:flex-none px-6 py-2 rounded-lg bg-hotpink text-white text-sm font-medium hover:bg-hotpink/90 transition-colors shadow-lg shadow-hotpink/20" data-id="element-52">
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}